import { render, staticRenderFns } from "./GoodsFormStep3.vue?vue&type=template&id=325e3ada&scoped=true&"
import script from "./GoodsFormStep3.vue?vue&type=script&lang=js&"
export * from "./GoodsFormStep3.vue?vue&type=script&lang=js&"
import style0 from "./GoodsFormStep3.vue?vue&type=style&index=0&id=325e3ada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325e3ada",
  null
  
)

export default component.exports